import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './imports/locales/en/translation.json'
import translationIT from './imports/locales/it/translation.json'

import professionsEN from './imports/locales/en/professions.json'
import professionsIT from './imports/locales/it/professions.json'

import nearbyPlacesEN from './imports/locales/en/nearbyPlaces.json'
import nearbyPlacesIT from './imports/locales/it/nearbyPlaces.json'

import servicesEN from './imports/locales/en/coworkingServices.json'
import servicesIT from './imports/locales/it/coworkingServices.json'

import privacyPolicyEN from './imports/locales/en/privacyPolicy.json'
import privacyPolicyIT from './imports/locales/it/privacyPolicy.json'

import cookiesPolicyEN from './imports/locales/en/cookiesPolicy.json'
import cookiesPolicyIT from './imports/locales/it/cookiesPolicy.json'

const resources = {
    it: {
        translation: translationIT,
        professions: professionsIT,
        nearbyPlaces: nearbyPlacesIT,
        services: servicesIT,
        privacyPolicy: privacyPolicyIT,
        cookiesPolicy: cookiesPolicyIT,
    },
    en: {
        translation: translationEN,
        professions: professionsEN,
        nearbyPlaces: nearbyPlacesEN,
        services: servicesEN,
        privacyPolicy: privacyPolicyEN,
        cookiesPolicy: cookiesPolicyEN,
    },
}

i18n.use(initReactI18next).init(
    {
        resources,
        lng: 'it',
        fallbackLng: 'en',

        interpolation: {
            escapeValue: false,
        },
    },
    (err, t) => {
        if (err) console.error('i18n init Error', err)
    }
)

export default i18n

export const dateFnsLocales = {
    en: require('date-fns/locale/en-GB'),
    it: require('date-fns/locale/it'),
}
